import { Component, OnInit } from '@angular/core';

@Component({
  templateUrl: './distributor-layout.component.html',
  styleUrls: ['./distributor-layout.component.scss']
})

export class DistributorLayoutComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
    $('body').addClass('distributor-layout');
  }
}
